import { render, staticRenderFns } from "./EducationForm.vue?vue&type=template&id=1a1b675b&scoped=true&"
import script from "./EducationForm.vue?vue&type=script&lang=js&"
export * from "./EducationForm.vue?vue&type=script&lang=js&"
import style0 from "./EducationForm.vue?vue&type=style&index=0&id=1a1b675b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1b675b",
  null
  
)

export default component.exports